<template>
  <div>
    <b-modal
      id="modal-publishNow"
      v-model="modal"
      body-class="publish-modal px-0"
      hide-footer
      hide-header
      lazy
      size="lg"
    >
      <i
        class="fa fa-close z-[50] absolute top-[15px] right-[17px] text-[16px] text-[#6E747A] transition cursor-pointer hover:opacity-60"
        @click="modal = false"
      />

      <div class="py-5">
        <h4 class="text-center title mb-3">
          Publish Your Project
        </h4>
        <h5 class="text-center subtitle">
          {{ project.name }}
        </h5>
      </div>

      <div class="border-bottom px-5">
        <b-row class="pages-header d-flex justify-content-between align-items-center text-uppercase pb-1">
          <b-col md="1">
            <div class="mr-auto">
              Status
            </div>
          </b-col>
          <b-col md="6">
            <div class="mr-auto">
              Page
            </div>
          </b-col>
          <b-col
            md="2"
            class="flex justify-end"
          >
            <div>Add To Backup</div>
          </b-col>
          <b-col
            md="3"
            class="flex justify-end"
          >
            <div>Unpublished / Published</div>
          </b-col>
        </b-row>
      </div>

      <div class="border-bottom py-4">
        <b-row class="d-flex justify-content-between align-items-center px-5">
          <b-col md="8">
            <div class="pub-all">
              Publish All
            </div>
          </b-col>
          <b-col
            md="4"
            class="text-center flex justify-end"
          >
            <b-checkbox
              v-model="allSelectedToHide"
              size="lg"
              switch
              @input="selectAllToHide"
            />
          </b-col>
        </b-row>
      </div>

      <div class="text-center my-4">
        <b-spinner
          v-if="!pages"
          variant="primary"
        />
      </div>

      <div
        ref="scroll"
        class="overflow-y-auto overflow-x-hidden max-h-[400px]"
      >
        <div
          v-if="pages"
          class="pages mb-4"
        >
          <div class="page-is_home border-bottom page-item cursor-pointer">
            <b-row class="d-flex justify-content-between align-items-center px-5">
              <b-col
                md="1"
                class="flex items-center justify-center"
              >
                <span
                  v-b-tooltip.hover
                  :title="{'ACTIVE': 'Published', 'ACTIVE_LEGACY_CSS': 'Published (Legacy CSS)', 'DRAFT': 'Unpublished'}[initialStatuses[currentPage.id]]"
                  class="relative flex w-[10px] h-[10px] rounded-full"
                  :class="[{'ACTIVE': 'bg-[#86c158]', 'ACTIVE_LEGACY_CSS': 'bg-[#fb923c]', 'DRAFT': 'bg-[#E2E5EC]'}[initialStatuses[currentPage.id]]]"
                />
              </b-col>
              <b-col
                md="6"
                @click.stop="selectPage(currentPage)"
              >
                <div class="py-3 w-100">
                  <div
                    class="page-name"
                    v-text="currentPage.title"
                  />
                  <div class="page-domain">
                    {{ getSiteHome }}/{{ currentPage.slug }}
                  </div>
                </div>
              </b-col>

              <b-col
                md="2"
                class="text-center flex justify-end"
              >
                <b-checkbox
                  v-model="versioned"
                  size="lg"
                  class="mt-[10px]"
                  @change="() => {
                    if (!versionedShowed) {
                      modal = false
                      versionedModal = true
                      versionedShowed = true
                    }
                  }"
                />
              </b-col>

              <b-col
                md="3"
                class="text-center flex justify-end"
              >
                <b-checkbox
                  v-model="currentPage.page_status"
                  size="lg"
                  switch
                  unchecked-value="DRAFT"
                  value="ACTIVE"
                />
              </b-col>
            </b-row>
          </div>

          <div
            v-for="(page) in pages.data.filter(p => p.id !== currentPage.id)"
            :key="page.id"
            class="border-bottom page-item cursor-pointer"
          >
            <b-row class="d-flex justify-content-between align-items-center px-5">
              <b-col
                md="1"
                class="flex items-center justify-center"
              >
                <span
                  v-b-tooltip.hover
                  :title="{'ACTIVE': 'Published', 'ACTIVE_LEGACY_CSS': 'Published (Legacy CSS)', 'DRAFT': 'Unpublished'}[initialStatuses[page.id]]"
                  class="relative flex w-[10px] h-[10px] rounded-full"
                  :class="[{'ACTIVE': 'bg-[#86c158]', 'ACTIVE_LEGACY_CSS': 'bg-[#fb923c]', 'DRAFT': 'bg-[#E2E5EC]'}[initialStatuses[page.id]]]"
                />
              </b-col>
              <b-col
                md="6"
                @click.stop="selectPage(page)"
              >
                <div class="py-3 w-100">
                  <div
                    class="page-name truncate"
                    v-text="page.title"
                  />
                  <div class="page-domain truncate">
                    {{ getSiteHome }}/{{ page.slug }}
                  </div>
                </div>
              </b-col>

              <b-col
                md="2"
                class="text-center flex justify-end"
              >
                <b-checkbox
                  :value="page.id"
                  size="lg"
                  class="mt-[10px] opacity-80"
                  @change="() => {
                    versions.push(page.id)
                    if (!versionedShowed) {
                      modal = false
                      versionedModal = true
                      versionedShowed = true
                    }
                  }"
                />
              </b-col>

              <b-col
                md="3"
                class="text-center flex justify-end"
              >
                <b-checkbox
                  v-model="page.page_status"
                  size="lg"
                  switch
                  unchecked-value="DRAFT"
                  value="ACTIVE"
                />
              </b-col>
            </b-row>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3 mb-3">
        <b-btn
          :disabled="loading || pageIsLoading"
          class="font-size-14 py-3 px-5 font-weight-bold"
          variant="primary"
          @click="publishNow"
        >
          {{ pageIsLoading ? 'Loading' : 'Update Publish Status' }}
          <b-spinner
            v-if="pageIsLoading || loading"
            class="ml-2"
            small
          />
        </b-btn>

        <!--        <b-dropdown-->
        <!--          v-if="selectPages.length"-->
        <!--          toggle-class="font-size-14 py-3 px-3 rounded-left-0 font-weight-bold border-left"-->
        <!--          variant="primary"-->
        <!--        >-->
        <!--          <template slot="button-content">-->
        <!--            <i-->
        <!--              class="fa fa-ellipsis-h dot-menu fa-lg link-muted cursor-pointer"-->
        <!--              icon="dot-menu.svg"-->
        <!--            />-->
        <!--          </template>-->

        <!--          <b-dropdown-item @click="openCreateTemplate">-->
        <!--            Create a new template with {{ selectPages.length }} page{{ selectPages.length > 1 ? 's' : '' }}-->
        <!--          </b-dropdown-item>-->
        <!--        </b-dropdown>-->
      </div>
    </b-modal>

    <b-modal
      v-model="versionedModal"
      hide-footer
      hide-header
      body-class="p-0"
      size="lg"
    >
      <div class="flex flex-col justify-center items-center text-center gap-y-3 py-5">
        <h4 class="text-[27px] text-center">
          Want to Create a Version Backup of This Page?
        </h4>
        <p class="text-center text-sm text-[#878787] max-w-[600px]">
          When you publish a page and select “Add to Backup”, ESTAGE saves a permanent version of this page exactly as it is at the moment of publishing.
          <br>
          These appear under "Version Backups" and remain stored until you publish a newer version with “Add to Backup” enabled - at which point the older version is replaced by the most recent one. Please double check to make sure this is the version you want to back up.
        </p>
        <b-btn
          variant="outline-primary"
          size="lg"
          @click="() => {
            versionedModal = false
            modal = true
          }"
        >
          Got It
        </b-btn>
      </div>
    </b-modal>

    <b-modal
      v-model="published"
      hide-footer
      hide-header
      size="lg"
    >
      <icon
        class="cursor-pointer ml-3"
        icon="close.svg"
        @click.native="published = false"
      />

      <div class="text-center py-5 my-5">
        <icon
          icon="positive-vote.svg"
          size="100px"
        />
        <h4 class="h3 text-center mt-4 mb-3">
          Your Page Has Been {{ ['ACTIVE_LEGACY_CSS', 'ACTIVE'].includes(currentStatus) ? 'Published' : 'Unpublished' }}
        </h4>
        <b-btn
          v-if="['ACTIVE_LEGACY_CSS', 'ACTIVE'].includes(currentStatus)"
          :href="getSiteHome + `/${currentPage.slug}`"
          class="mb-4"
          target="_blank"
          variant="outline-primary"
        >
          View Online
        </b-btn>
        <b-btn
          v-else
          class="mb-4"
          variant="outline-primary"
          @click="published = false"
        >
          Close
        </b-btn>
      </div>
    </b-modal>

    <create-own-template-modal
      v-model="createTemplateModal"
      :selected-pages="selectedPages"
    />
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import RouterMixin from '../../mixins/RouterMixin'
import _ from 'lodash'
import PagesPaginationMixin from '../mixins/PagesPaginationMixin'
import html2canvas from 'html2canvas'
import CreateOwnTemplateModal from './CreateOwnTemplateModal'

export default {
  name: 'PublishModal',
  components: {CreateOwnTemplateModal},
  mixins: [RouterMixin, PagesPaginationMixin],
  data () {
    return {
      published: false,
      selectPages: [],
      allSelected: false,
      allSelectedToHide: false,
      loading: false,
      modal: false,
      pages: null,
      createTemplateModal: false,
      currentStatus: 'DRAFT',
      initialStatuses: {},
      versioned: false,
      versionedShowed: false,
      versionedModal: false,
      versions: []
    }
  },
  computed: {
    ...mapGetters('pages', {
      allPages: 'getPages'
    }),
    ...mapState('projects', {
      project: state => state.project
    }),
    ...mapState('pages', {
      currentPage: state => state.page
    }),
    ...mapState('editor', {
      element: (state) => state.element,
      section: (state) => state.section
    }),
    selectedPages () {
      return this.selectPages.map(id => {
        return {
          id,
          ..._.find(this.pages.data, ['id', id])
        }
      })
    },
    getSiteHome () {
      return this.project.domain ? this.addhttp(this.project.domain).replace('http://', 'https://') : `https://${this.project.subdomain}.${process.env.VUE_APP_ESTAGE_DOMAIN_HOST || 'estage.site'}`
    }
  },
  watch: {
    async modal (val) {
      if (val) {
        this.$refs.scroll.addEventListener('scroll', this.scrollLoadingPages)
        this.selectPages.push(this.currentPage.id)
        this.pages = JSON.parse(JSON.stringify(this.allPages))
        this.initialStatuses = (this.allPages && this.allPages.data)
          ? this.allPages.data.reduce((acc, p) => {
            if (p.page_status === 'ACTIVE' && !p.css_file) acc[p.id] = 'ACTIVE_LEGACY_CSS'
            else acc[p.id] = p.page_status
            return acc
          }, {})
          : {}
        this.currentPage.page_status = 'ACTIVE'
      } else {
        if (!this.createTemplateModal) {
          this.selectPages = []
        }
        this.currentPaginationPage = 1
        this.$refs.scroll.removeEventListener('scroll', this.scrollLoadingPages)
        this.initialStatuses = {}
      }
    },
    async createTemplateModal (val) {
      if (!val) {
        this.selectPages = []
      }
    },
    async pageIsLoading (val) {
      if (this.modal && !val && this.allSelectedToHide) this.selectAllToHide()
    }
  },
  methods: {
    openCreateTemplate () {
      this.modal = false
      this.createTemplateModal = true
    },
    setResolution (resolution) {
      document.querySelector('.es-root').style.width = null

      if (resolution === 'md') {
        this.$store.commit('editor/SET_TABLET', true)
        this.$store.commit('editor/SET_RESOLUTION', 'sm')
      } else {
        this.$store.commit('editor/SET_TABLET', false)
        this.$store.commit('editor/SET_RESOLUTION', resolution)
      }

      if (!this.section) return

      setTimeout(() => {
        const element =
            this.element ||
            document.querySelector(`[data-uid="${this.section.uid}"]`)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }
      }, 100)
    },
    async publishNow () {
      if (!this.$store.getters['sections/getSections'].length) {
        this.$store.commit('projects/SET_PUBLISING', false)
        this.loading = false
        this.pageIsLoading = false
        this.modal = false
        this.$swal({
          icon: 'warning',
          title: 'Your page is empty',
          text: 'You need to add some elements to your page before publishing.',
          showConfirmButton: false
        })
        return
      }

      this.$store.commit('projects/SET_PUBLISING', true)
      VEvent.fire('loader', true)
      this.loading = true
      this.pageIsLoading = true
      this.currentStatus = this.currentPage.page_status

      setTimeout(async () => {
        const draft = JSON.stringify(this.$store.getters['sections/getSections'])
        if (this.versioned) {
          const versionBackup = {
            original_id: this.currentPage.id,
            slug: this.currentPage.slug,
            title: this.currentPage.title,
            content: this.currentPage.content,
            content_draft: draft,
            settings: JSON.stringify(this.currentPage.settings),
            fonts: this.currentPage.fonts,
            css_hash: this.currentPage.css_hash,
            css_file: this.currentPage.css_file,
            css_file_draft: this.currentPage.css_file_draft,
            hash: this.currentPage.hash,
            original_css: this.project.css_file_draft,
            page_status: 'DRAFT',
            project_id: this.project.id
          }
          await this.$store.dispatch('backups/postVersionBackup', versionBackup)
        }

        if (this.versions.length > 0) {
          await this.$store.dispatch('backups/postVersionBackupList', this.versions)
        }

        await this.$store.dispatch('projects/publish', {
          all: this.allSelected,
          pages: [this.currentPage, ...this.pages.data.filter(p => p.id !== this.currentPage.id)].map(page => {
            return {
              id: page.id,
              status: page.page_status,
              updContent: true
            }
          }),
          callback: () => {
            VEvent.fire('loader', false)
            this.versioned = false
            this.versions = []
            this.$store.commit('projects/SET_PUBLISING', false)
            this.$store.dispatch('pages/loadPages')
            this.loading = false
            this.pageIsLoading = false
            this.modal = false
            this.published = true
            if (this.currentPage.is_home) {
              this.takeScreenShot()
            }
          }
        }, {call: true})
          .catch((err) => {
            VEvent.fire('loader', false)
            console.error(err.error)
            this.$store.commit('projects/SET_PUBLISING', false)
            this.loading = false
            this.pageIsLoading = false
            this.modal = false
            this.$swal({
              icon: err.icon ?? 'error',
              title: err.title ?? 'Something went wrong',
              text: err.error ?? 'Please try again later or let us know about your problem.',
              showConfirmButton: false,
              timer: 5000
            })
          })
      }, 250)
    },
    async takeScreenShot () {
      await html2canvas(document.querySelector('.es-root'), {
        scrollX: 0,
        scrollY: -window.scrollY,
        useCORS: true,
        logging: false
      }).then(canvas => {
        let croppedCanvas = document.createElement('canvas'),
          croppedCanvasContext = croppedCanvas.getContext('2d')

        croppedCanvas.width = canvas.width
        croppedCanvas.height = 1900

        croppedCanvasContext.drawImage(canvas, 0, 0, canvas.width, 1900, 0, 0, canvas.width, 1900)

        axios.put(`api/projects/${this.project.id}/screenshot`, {
          screenshot: croppedCanvas.toDataURL()
        })
      })
    },
    initialPageStatus (id) {
      return this.initialStatuses[id] ?? null
    },
    selectPage (page) {
      if (this.selectPages.includes(page.id)) {
        return this.selectPages.splice(_.findIndex(this.selectPages, i => i === page.id), 1)
      }

      this.selectPages.push(page.id)
    },
    selectAll () {
      if (this.selectPages.length && !this.allSelected) {
        this.allSelected = false
        return this.selectPages = []
      }

      this.allSelected = true
      return this.selectPages = this.pages.data.map(p => p.id)
    },
    selectAllToHide () {
      this.currentPage.page_status = !this.allSelectedToHide ? 'DRAFT' : 'ACTIVE'
      this.pages.data.forEach(p => {
        p.page_status = !this.allSelectedToHide ? 'DRAFT' : 'ACTIVE'
      })
    }
  }
}
</script>

<style lang="scss">
.publish-modal {
  .title,
  .subtitle {
    font-family: 'ProximaNova';
  }

  .title {
    font-weight: 600;
    font-size: 27px;
  }

  .subtitle {
    font-size: 19px;
    font-weight: 300;
    color: #979797;
  }

  .pages-header {
    font-weight: bold;
    letter-spacing: 1px;
    font-size: 9px;
    color: #AEB1B4;
  }

  .pub-all {
    font-style: italic;
    font-size: 15px;
    line-height: 20px;
    color: #6E747A;
  }

  .page-name {
    color: #6E747A;
    font-size: 15px;
  }

  .page-domain {
    color: #AEB1B4;
    font-size: 14px;
  }

  .page-item {
    transition: background .2s;

    &:hover {
      background: #eee;
    }
  }

  .page-is_home {
    background: #F2F3F5;

    .page-name {
      font-weight: bold;
      color: #333333;
    }
  }
}

#modal-publishNow___BV_modal_outer_ {
  z-index: 100000000000 !important;
}
</style>